import React, { useEffect, useState } from 'react';
import { TwoFactorAuthenticationStates } from '@tradingblock/types';
import PrimaryButton from '../components/PrimaryButton';
;
const Intro = ({ twoFactorAuthenticationState, primaryButtonProps }) => {
    const [mainContent, setMainContent] = useState(null);
    const getTwoFactorAuthenticationMethodTextBasedOnState = () => {
        if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.FirstTimeSetupAndEmailMethodNotVerified ||
            twoFactorAuthenticationState === TwoFactorAuthenticationStates.DisabledByAdminAndEmailMethodNotVerified ||
            twoFactorAuthenticationState === TwoFactorAuthenticationStates.EnabledAndEmailMethodNotVerified) {
            return 'email';
        }
        else if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.FirstTimeSetupAndSmsMethodNotVerified ||
            twoFactorAuthenticationState === TwoFactorAuthenticationStates.DisabledByAdminAndSmsMethodNotVerified ||
            twoFactorAuthenticationState === TwoFactorAuthenticationStates.EnabledAndSmsMethodNotVerified) {
            return 'text';
        }
        return '';
    };
    useEffect(() => {
        if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.FirstTimeSetupAndNoVerifiedMethods) {
            setMainContent(React.createElement(React.Fragment, null,
                React.createElement("p", null, "Let's keep your account safe."),
                React.createElement("p", null, "Two-factor authentication (2FA) protects your investments from unauthorized access even if your password is compromised."),
                React.createElement("p", null, "Setup takes 2 minutes and provides lasting protection. You'll need access to your mobile phone and email address.")));
        }
        else if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.DisabledByAdminAndNoVerifiedMethods) {
            setMainContent(React.createElement(React.Fragment, null,
                React.createElement("p", null, "Two-factor authentication has been disabled."),
                React.createElement("p", null, "Let's get two-factor authentication set up again. It will only take a few minutes.")));
        }
        else if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.FirstTimeSetupAndEmailMethodNotVerified ||
            twoFactorAuthenticationState === TwoFactorAuthenticationStates.FirstTimeSetupAndSmsMethodNotVerified) {
            setMainContent(React.createElement(React.Fragment, null,
                React.createElement("p", null, "Almost there!"),
                React.createElement("p", null,
                    "To finish setting up two-factor authentication, we need to verify the ",
                    getTwoFactorAuthenticationMethodTextBasedOnState(),
                    " method.")));
        }
        else if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.DisabledByAdminAndEmailMethodNotVerified ||
            twoFactorAuthenticationState === TwoFactorAuthenticationStates.DisabledByAdminAndSmsMethodNotVerified) {
            setMainContent(React.createElement(React.Fragment, null,
                React.createElement("p", null, "Two-factor authentication has been disabled."),
                React.createElement("p", null,
                    "Please verify the ",
                    getTwoFactorAuthenticationMethodTextBasedOnState(),
                    " two-factor authentication method in order to complete the setup of two-factor authentication.")));
        }
        else if (twoFactorAuthenticationState === TwoFactorAuthenticationStates.EnabledAndEmailMethodNotVerified ||
            twoFactorAuthenticationState === TwoFactorAuthenticationStates.EnabledAndSmsMethodNotVerified) {
            setMainContent(React.createElement(React.Fragment, null,
                React.createElement("p", null, "Two-factor authentication is currently enabled, however you are missing a back up two-factor authentication method."),
                React.createElement("p", null,
                    "Please take a few minutes to set up the ",
                    getTwoFactorAuthenticationMethodTextBasedOnState(),
                    " two-factor authentication method.")));
        }
    }, [twoFactorAuthenticationState]);
    return (React.createElement(React.Fragment, null,
        mainContent,
        React.createElement("div", { className: "btn-wrapper" },
            React.createElement(PrimaryButton, Object.assign({}, primaryButtonProps)))));
};
export default Intro;
//# sourceMappingURL=Intro.js.map